<template>
	<div class="type-helper">
		<table>
			<tr>
				<td style="width:35px; vertical-align: top;">
					<v-icon>
						mdi-help-circle-outline
					</v-icon>
				</td>
				<td>
					A key performance indicator (KPI) is a measurable value that demonstrates how effectively {{ $term('employee', { article: true }) }} is performing in regards to key strategic goals. A high quality KPI should act as a compass, helping the {{ $term('employee') }} and
					supervisor/manager understand whether the right path is being taken towards strategic goals.

					<a v-show="!showMore" href="#" @click="showMore = !showMore">Learn More...</a>
					<a v-show="showMore" href="#" @click="showMore = !showMore">Show Less...</a>
					<v-slide-y-transition>
						<div v-show="showMore">
							<div class="mt-2">To be effective, a KPI must:</div>

							<ul>
								<li>Be well-defined and quantifiable</li>
								<li>Provide a measure on the highest return on investment (ROI) activities</li>
								<li>Be crucial to achieving goals</li>
								<li>Match the {{ $term('employee', { possessive: true }) }} level of competence and authority</li>
								<li>No more than 5 KPI’s in place</li>
							</ul>
						</div>
					</v-slide-y-transition>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showMore: false
			};
		}
	};
</script>

<style scoped>
	.type-helper {
		font-size: 14px;
		text-align: left;
		margin-bottom: 40px;
		margin-top: 10px;
		color: rgba(0, 0, 0, 0.54);
	}
</style>
